import { render } from "./LongTextInput.vue?vue&type=template&id=6dc49882&scoped=true"
import script from "./LongTextInput.vue?vue&type=script&lang=js"
export * from "./LongTextInput.vue?vue&type=script&lang=js"

import "./LongTextInput.vue?vue&type=style&index=0&id=6dc49882&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc49882"]])

export default __exports__